import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const trackproConfig: TSPConfig = {
  key: 'trackpro',
  name: 'Trackpro',
  category: TSPCategory.API_KEY,
  helpText: (
    <>
      <p>Connect to Trackpro by entering your API key.</p>
      <p>
        You can find your API key in your Trackpro dashboard under Settings →
        API Access.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default trackproConfig;
